'use client';

import { c as _c } from "react/compiler-runtime";
import type { Condition } from '@repo/api-gw-sdk';
import { useSearchParams } from 'next/navigation';
import { createContext, useReducer, useRef, type Dispatch, type PropsWithChildren, type SetStateAction } from 'react';
import { createCombineCondition, isValueCondition } from '@/types/advanceFilter';
import { deserializeSearchParams } from './serialization';
const normalizeFilter = (filter: Condition | undefined) => {
  if (!filter) {
    return undefined;
  }
  if (isValueCondition(filter)) {
    return createCombineCondition([filter]);
  }
  return !filter.conditions?.length ? undefined : filter;
};
export const ViewParametersContext = createContext<{
  version: number;
  params: () => Record<string, unknown>;
  setParams: Dispatch<SetStateAction<Record<string, unknown>>>;
  setInitialValues: (initialValues: Record<string, unknown>) => void;
  setParamsWithoutRender: (newParams: Record<string, unknown>) => void;
} | undefined>(undefined);
export const ViewParametersProvider = t0 => {
  const $ = _c(12);
  const {
    children
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = deserializeSearchParams(searchParams);
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const deserializedSearchParams = t1;
  const params = useRef(deserializedSearchParams);
  const [version, forceUpdate] = useReducer(_temp, 0);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (newParams, render) => {
      if (newParams?.query) {
        newParams.query = normalizeFilter(newParams.query as Condition);
      }
      if (typeof newParams.pageIndex === "number" && params.current.query !== newParams.query) {
        newParams.pageIndex = 0;
      }
      params.current = newParams;
      if (render) {
        forceUpdate();
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setParams = t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => params.current;
    t4 = initialValues => {
      setParams(initialValues, true);
    };
    t5 = newParams_0 => {
      setParams(newParams_0, false);
    };
    t6 = p => {
      const newParams_1 = typeof p === "function" ? p(params.current || {}) : p;
      setParams(newParams_1, true);
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== version) {
    t7 = {
      version,
      params: t3,
      setInitialValues: t4,
      setParamsWithoutRender: t5,
      setParams: t6
    };
    $[7] = version;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== children || $[10] !== t7) {
    t8 = <ViewParametersContext.Provider value={t7}>{children}</ViewParametersContext.Provider>;
    $[9] = children;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
function _temp(x) {
  return x + 1;
}